import { TSuggest } from 'feature/registration/types'
import { debounce } from 'helpers/debounce'
import { sendRequestNoAuthLkp } from 'transport/sendRequestNoAuth'

// получение подсказок Dadata по координатам
export const getSuggestsQueryByCoords = async (
  geoLat: string,
  geoLon: string,
) => {
  const res = await sendRequestNoAuthLkp.post<TSuggest[]>(
    '/v1/dadata/geolocate/address',
    {
      geoLat: parseFloat(geoLat),
      geoLon: parseFloat(geoLon),
    },
  )

  if (res && res.data) {
    const dataWithAddress = res.data.map(item => ({
      ...item,
      //@ts-ignore
      address: item.value,
    }))

    return { ...res, data: dataWithAddress }
  }

  return res
}

export const debouncedGetSuggestsQueryByCoords = debounce(
  getSuggestsQueryByCoords,
  300,
)
